import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule, Router } from '@angular/router';
import { AuthService } from '../../auth/auth.service';

@Component({
  selector: 'app-sidebar',
  standalone: true,
  imports: [CommonModule, RouterModule],
  template: `
    <aside class="w-20 h-full flex flex-col items-center py-6 space-y-6" style="background-color: #171f39;">
      <!-- Logo/Icon en haut -->
      <div class="w-8 h-8 bg-primary rounded-lg flex items-center justify-center">
        <svg width="18" height="18" viewBox="0 0 24 24" fill="white">
          <path d="M12 2L2 7l10 5 10-5-10-5zM2 17l10 5 10-5M2 12l10 5 10-5"/>
        </svg>
      </div>

      <!-- Navigation -->
      <nav class="flex flex-col space-y-4">
        <!-- Dashboard -->
        <a routerLink="/dashboard" 
           routerLinkActive="text-adapei-primary" 
           [routerLinkActiveOptions]="{ exact: true }"
           class="w-10 h-10 flex items-center justify-center text-slate-400 hover:text-white transition-all duration-200 group">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M3 13h8V3H3v10zm0 8h8v-6H3v6zm10 0h8V11h-8v10zm0-18v6h8V3h-8z"/>
          </svg>
        </a>

        <!-- Convives -->
        <a routerLink="/convives" 
           routerLinkActive="text-adapei-primary"
           class="w-10 h-10 flex items-center justify-center text-slate-400 hover:text-white transition-all duration-200 group">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M16 11c1.66 0 2.99-1.34 2.99-3S17.66 5 16 5c-1.66 0-3 1.34-3 3s1.34 3 3 3zm-8 0c1.66 0 2.99-1.34 2.99-3S9.66 5 8 5C6.34 5 5 6.34 5 8s1.34 3 3 3zm0 2c-2.33 0-7 1.17-7 3.5V19h14v-2.5c0-2.33-4.67-3.5-7-3.5zm8 0c-.29 0-.62.02-.97.05 1.16.84 1.97 1.97 1.97 3.45V19h6v-2.5c0-2.33-4.67-3.5-7-3.5z"/>
          </svg>
        </a>

        <!-- Menus -->
        <a routerLink="/menus/calendar" 
           routerLinkActive="text-adapei-primary"
           class="w-10 h-10 flex items-center justify-center text-slate-400 hover:text-white transition-all duration-200 group">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M8.1 13.34l2.83-2.83L3.91 3.5c-1.56 1.56-1.56 4.09 0 5.66l4.19 4.18zm6.78-1.81c1.53.71 3.68.21 5.27-1.38 1.91-1.91 2.28-4.65.81-6.12-1.46-1.46-4.20-1.10-6.12.81-1.59 1.59-2.09 3.74-1.38 5.27L3.7 19.87l1.41 1.41L12 14.41l6.88 6.88 1.41-1.41L13.41 13l1.47-1.47z"/>
          </svg>
        </a>

        <!-- Commandes -->
        <a routerLink="/commandes" 
           routerLinkActive="text-adapei-primary"
           class="w-10 h-10 flex items-center justify-center text-slate-400 hover:text-white transition-all duration-200 group">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M19 7h-3V6a4 4 0 0 0-8 0v1H5a1 1 0 0 0-1 1v11a3 3 0 0 0 3 3h10a3 3 0 0 0 3-3V8a1 1 0 0 0-1-1zM10 6a2 2 0 0 1 4 0v1h-4V6zm8 13a1 1 0 0 1-1 1H7a1 1 0 0 1-1-1V9h2v1a1 1 0 0 0 2 0V9h4v1a1 1 0 0 0 2 0V9h2v10z"/>
          </svg>
        </a>

        <!-- Pré-facturation -->
        <a routerLink="/prefacturation/recap-par-journees" 
           routerLinkActive="text-adapei-primary"
           class="w-10 h-10 flex items-center justify-center text-slate-400 hover:text-white transition-all duration-200 group">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M14 2H6c-1.1 0-1.99.9-1.99 2L4 20c0 1.1.89 2 1.99 2H18c1.1 0 2-.9 2-2V8l-6-6zm2 16H8v-2h8v2zm0-4H8v-2h8v2zm-3-5V3.5L18.5 9H13z"/>
          </svg>
        </a>

        <!-- Rapports -->
        <a routerLink="/reports" 
           routerLinkActive="text-adapei-primary"
           class="w-10 h-10 flex items-center justify-center text-slate-400 hover:text-white transition-all duration-200 group">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M9 17H7v-7h2v7zm4 0h-2V7h2v10zm4 0h-2v-4h2v4zm2.5 2.25l1.25-1.25-2.75-2.75-1.25 1.25L19.5 19.25zM12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2z"/>
          </svg>
        </a>

       
      </nav>

      <!-- Paramètres et Déconnexion en bas -->
      <div class="flex-1 flex flex-col justify-end space-y-4 items-center">
        <a routerLink="/settings" 
           routerLinkActive="text-adapei-primary"
           class="w-10 h-10 flex items-center justify-center text-slate-400 hover:text-white transition-all duration-200">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M19.14,12.94c0.04-0.3,0.06-0.61,0.06-0.94c0-0.32-0.02-0.64-0.07-0.94l2.03-1.58c0.18-0.14,0.23-0.41,0.12-0.61 l-1.92-3.32c-0.12-0.22-0.37-0.29-0.59-0.22l-2.39,0.96c-0.5-0.38-1.03-0.7-1.62-0.94L14.4,2.81c-0.04-0.24-0.24-0.41-0.48-0.41 h-3.84c-0.24,0-0.43,0.17-0.47,0.41L9.25,5.35C8.66,5.59,8.12,5.92,7.63,6.29L5.24,5.33c-0.22-0.08-0.47,0-0.59,0.22L2.74,8.87 C2.62,9.08,2.66,9.34,2.86,9.48l2.03,1.58C4.84,11.36,4.8,11.69,4.8,12s0.02,0.64,0.07,0.94l-2.03,1.58 c-0.18,0.14-0.23,0.41-0.12,0.61l1.92,3.32c0.12,0.22,0.37,0.29,0.59,0.22l2.39-0.96c0.5,0.38,1.03,0.7,1.62,0.94l0.36,2.54 c0.05,0.24,0.24,0.41,0.48,0.41h3.84c0.24,0,0.44-0.17,0.47-0.41l0.36-2.54c0.59-0.24,1.13-0.56,1.62-0.94l2.39,0.96 c0.22,0.08,0.47,0,0.59-0.22l1.92-3.32c0.12-0.22,0.07-0.47-0.12-0.61L19.14,12.94z M12,15.6c-1.98,0-3.6-1.62-3.6-3.6 s1.62-3.6,3.6-3.6s3.6,1.62,3.6,3.6S13.98,15.6,12,15.6z"/>
          </svg>
        </a>
        <button (click)="onLogout()"
                class="w-10 h-10 flex items-center justify-center text-slate-400 hover:text-red-400 transition-all duration-200 cursor-pointer"
                title="Déconnexion">
          <svg width="20" height="20" viewBox="0 0 24 24" fill="currentColor">
            <path d="M17 7l-1.41 1.41L18.17 11H8v2h10.17l-2.58 2.58L17 17l5-5zM4 5h8V3H4c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h8v-2H4V5z"/>
          </svg>
        </button>
      </div>
    </aside>
  `
})
export class SidebarComponent {
  constructor(private router: Router, private authService: AuthService) {}

  onLogout(): void {
    this.authService.logout();
  }
}
